/* eslint-disable */
export const region3Barangays = [
    {
        CITY: 'ABUCAY',
        BARANGAY: 'BANGKAL',
    },
    {
        CITY: 'ABUCAY',
        BARANGAY: 'CALAYLAYAN (POB.)',
    },
    {
        CITY: 'ABUCAY',
        BARANGAY: 'CAPITANGAN',
    },
    {
        CITY: 'ABUCAY',
        BARANGAY: 'GABON',
    },
    {
        CITY: 'ABUCAY',
        BARANGAY: 'LAON (POB.)',
    },
    {
        CITY: 'ABUCAY',
        BARANGAY: 'MABATANG',
    },
    {
        CITY: 'ABUCAY',
        BARANGAY: 'OMBOY',
    },
    {
        CITY: 'ABUCAY',
        BARANGAY: 'SALIAN',
    },
    {
        CITY: 'ABUCAY',
        BARANGAY: 'WAWA (POB.)',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'ATILANO L. RICARDO',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'BAGUMBAYAN (POB.)',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'BANAWANG',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'BINUANGAN',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'BINUKAWAN',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'IBABA',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'IBIS',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'PAG-ASA (WAWA-SIBACAN)',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'PARANG',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'PAYSAWAN',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'QUINAWAN',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'SAYSAIN',
    },
    {
        CITY: 'BAGAC',
        BARANGAY: 'TABING-ILOG (POB.)',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'CABOG-CABOG',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'CAMACHO',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'CATANING',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'CENTRAL',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'CUPANG NORTH',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'CUPANG PROPER',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'CUPANG WEST',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'DANGCOL (BERNABE)',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'DONA FRANCISCA',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'IBAYO',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'LOTE',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'MALABIA',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'MUNTING BATANGAS (CADRE)',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'PTO. RIVAS IBABA',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'PTO. RIVAS ITAAS',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'SIBACAN',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'TANATO',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'TENEJERO',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'TORTUGAS',
    },
    {
        CITY: 'BALANGA',
        BARANGAY: 'TUYO',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'BINARITAN',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'MABAYO',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'NAGBALAYONG',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MORONG',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'ALA-ULI',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BALUT I',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BALUT II',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BANTAN MUNTI',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DEL ROSARIO (POB.)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DIWA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LANDING',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LIYANG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'NAGWALING',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PANILAO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PANTINGAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'WAKAS NORTH',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'WAKAS SOUTH',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'AQUINO',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'BANGAL',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'BAYAN-BAYANAN',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'BONIFACIO (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'BURGOS (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'COLO',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'DAANG BAGO',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'DALAO',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'DEL PILAR (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'GEN. LUNA (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'GOMEZ (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'HAPPY VALLEY',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'JOSE C. PAYUMO',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'JOSE C. PAYUMO JR.',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'KATAASAN',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'LAYAC',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'LUACAN',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'MABINI EXT. (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'MABINI PROPER (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'NAPARING',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'NEW SAN JOSE',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'OLD SAN JOSE',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'PADRE DANDAN (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'PAGALANGGANG',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'PAYANGAN',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'PENTOR',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'PINULOT',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'PITA',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'ROOSEVELT',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'ROXAS (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'SAGUING',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'SAN BENITO',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'SAN PABLO (BULATE)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'SAN SIMON',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'SANTA ISABEL (TABACAN)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'SAPANG BALAS',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'TORRES BUGAUEN (POB.)',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'TUBO-TUBO',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'TUCOP',
    },
    {
        CITY: 'DINALUPIHAN',
        BARANGAY: 'ZAMORA (POB.)',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'A. RIVERA (POB.)',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'ALMACEN',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'BALSIC',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'BAMBAN',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'BURGOS-SOLIMAN (POB.)',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'CATANING (POB.)',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'CULIS',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'DAUNGAN (POB.)',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'JUDGE ROMAN CRUZ SR. (MANDAMA)',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'MABIGA',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'MABUCO',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'MAITE',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'MAMBOG - MANDAMA',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'PALIHAN',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'PANDATUNG',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'PULO',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'SABA',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'SACRIFICE VALLEY',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'SANTO CRISTO (POB.)',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'SUMALO',
    },
    {
        CITY: 'HERMOSA',
        BARANGAY: 'TIPO',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'ALANGAN',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'DUALE',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'KITANG 2 & LUZ',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'KITANG I',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'LAMAO',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'LANDING',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'REFORMISTA',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'SAN FRANCISCO DE ASIS',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'ST. FRANCIS II',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'TOWNSITE',
    },
    {
        CITY: 'LIMAY',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'ALAS-ASIN',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'ALION',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'BALON-ANITO',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'BASECO COUNTRY (NASSCO)',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'BATANGAS II',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'BIAAN',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'CABCABEN',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'CAMAYA',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'IPAG',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'LUCANIN',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'MALAYA',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'MT. VIEW',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'SISIMAN',
    },
    {
        CITY: 'MARIVELES',
        BARANGAY: 'TOWNSITE',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'APOLLO',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'BAGONG PARAISO (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'BALUT (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'BAYAN (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'CALERO (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'DONA',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'KABALUTAN',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'KAPARANGAN',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'MARIA FE',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'MASANTOL',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'MULAWIN',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'PAKING-CARBONERO (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'PALIHAN (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'PANTALAN BAGO (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'PANTALAN LUMA (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'PARANG PARANG (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'PUKSUAN',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'SIBUL',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'SILAHIS',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'TALA',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'TALIMUNDOC',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'TAPULAO',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'TENEJERO (POB.)',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'TUGATOG',
    },
    {
        CITY: 'ORANI',
        BARANGAY: 'WAWA (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'ARELLANO (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'BAGUMBAYAN (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'BALAGTAS (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'BALUT (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'BANTAN',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'BILOLO',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'CALUNGUSAN',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'CAMACHILE',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'DAANG BAGO (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'DAANG BILOLO (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'DAANG PARE',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'GENERAL LIM (KAPUT)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'KAPUNITAN',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'LATI (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'LUSUNGAN (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'PUTING BUHANGIN',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'SABATAN',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'VILLA ANGELES (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'WAKAS (POB.)',
    },
    {
        CITY: 'ORION',
        BARANGAY: 'WAWA (POB.)',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'EAST CALAGUIMAN (POB.)',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'EAST DAANG BAGO (POB.)',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'GUGO',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'IBABA (POB.)',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'LALAWIGAN',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'PALILI',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'SAPA',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'TABING ILOG',
    },
    {
        CITY: 'SAMAL',
        BARANGAY: 'WEST CALAGUIMAN (POB.)',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'BETES',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'BIBICLAT',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'BUCOT',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'LA PURISIMA',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'MACABUCOD',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'PANTOC',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'POBLACION CENTRO',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'POBLACION EAST I',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'POBLACION EAST II',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'POBLACION WEST III',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'POBLACION WEST IV',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SAN EMILIANO',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SAN EUSTACIO',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SAN FELIPE BATA',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SAN FELIPE MATANDA',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SAN PABLO BATA',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SAN PABLO MATANDA',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'SUNSON',
    },
    {
        CITY: 'ALIAGA',
        BARANGAY: 'UMANGAN',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'ARIENDO',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'CALAANAN',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'COMMERCIAL (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'CRUZ',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'CURVA (J. TOMACRUZ)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'DIGMALA',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'KAINGIN (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'LABI',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'LARCON',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'LUSOK',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'MACABACLAY',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'MAGTANGGOL (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'MANTILE (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'OLIVETE',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'PALO MARIA (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'PESA',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'SAMPALUCAN (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'SINIPIT (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'SISILANG NA LIGAYA (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'SOCIAL (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'TUGATUG',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'TULAY NA BATO (POB.)',
    },
    {
        CITY: 'BONGABON',
        BARANGAY: 'VEGA',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'ADUAS CENTRO (ADUAS)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'ADUAS NORTE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'ADUAS SUR',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BAGONG BUHAY',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BAKERO',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BAKOD BAYAN',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BANGAD',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BANTUG BULALO',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BANTUG NORTE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BARLIS',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BARRERA DISTRICT (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BERNARDO DISTRICT (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BITAS',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BONIFACIO DISTRICT (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'BULIRAN',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'CAALIBANGBANGAN',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'CABU',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'CALAWAGAN (KALAWAGAN)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'CAMPO TINIO',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'CAUDILLO',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'CINCO-CINCO',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'CITY SUPERMARKET (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'COMMUNAL',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'CRUZ ROJA',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'DAANG SARILE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'DALAMPANG',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'DICARMA (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'DIMASALANG (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'DIONISIO S. GARCIA',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'FATIMA (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'GENERAL LUNA (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'HERMOGENES C. CONCEPCION',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'IBABAO BANA',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'IMELDA DISTRICT',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'ISLA (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'KALIKID NORTE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'KALIKID SUR',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'KAPITAN PEPE (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'LAGARE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'LOURDES (MATUNGAL-TUNGAL)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'M. S. GARCIA',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'MABINI EXTENSION',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'MABINI HOMESITE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'MACATBONG',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'MAGSAYSAY DISTRICT',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'MAGSAYSAY SOUTH',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'MARIA THERESA',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'MATADERO (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'MAYAPYAP NORTE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'MAYAPYAP SUR',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'MELOJAVILLA (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'NABAO (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'OBRERO',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'PADRE BURGOS (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'PADRE CRISOSTOMO',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'PAGAS',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'PALAGAY',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'PAMALDAN',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'PANGATIAN',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'PATALAC',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'POLILIO',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'PULA',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'QUEZON DISTRICT (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'RIZDELIS (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SAMON',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SAN JOSEF NORTE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SAN JOSEF SUR',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SAN JUAN POB. (ACOFA)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SAN ROQUE NORTE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SAN ROQUE SUR',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SANBERMICRISTI (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SANGITAN',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SANGITAN EAST',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SANTA ARCADIA',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SAPANG',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SUMACAB ESTE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SUMACAB NORTE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'SUMACAB SOUTH',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'TALIPAPA',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'VALDEFUENTE',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'VALLE CRUZ',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'VIJANDRE DISTRICT (POB.)',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'VILLA OFELIA-CARIDAD',
    },
    {
        CITY: 'CABANATUAN',
        BARANGAY: 'ZULUETA DISTRICT (POB.)',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'BAGONG BUHAY',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'ENTABLADO',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'NATIVIDAD NORTH (POB.)',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'NATIVIDAD SOUTH (POB.)',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'PALASINAN',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'POLILIO',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SAN FERNANDO NORTE',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SAN FERNANDO SUR',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SAN JUAN NORTH (POB.)',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SAN JUAN SOUTH (POB.)',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'CABIAO',
        BARANGAY: 'SINIPIT',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'CAPINTALAN',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'D. L. MAGLANOC POB. (BGY.III)',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'F. C. OTIC POB. (BGY. II)',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'G. S. ROSARIO POB. (BGY. IV)',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'JOSON (DIGIDIG)',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'MINULI',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'PIUT',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'PUNCAN',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'PUTLAN',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'R.A.PADILLA (BALUARTE)',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'SALAZAR',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'CARRANGLAN',
        BARANGAY: 'T. L. PADILLA POB. (BGY. I)',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'BALOY',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'BAMBANABA',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'BENTIGAN',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'BIBICLAT',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'BUED',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'BULALA',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'CABATUAN',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'CABILEO',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'CACAPASAN',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'CALANCUASAN NORTE',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'CALANCUASAN SUR',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'COLOSBOA',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'COLUMBITIN',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'CURVA',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'DISTRICT I (POB. I)',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'DISTRICT II (POB. II)',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'DISTRICT IV (POB. IV)',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'DISTRICT V (POB. V)',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'DISTRICT VI (POB. VI)',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'DISTRICT VII (POB. VII)',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'DISTRICT VIII (POB. VIII)',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'LANDIG',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'LATAP',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'LOOB',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'MALBEG-PATALAN',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'MALINENG',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'MATINDEG',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'MAYCABAN',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'NACURALAN',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'NAGMISAHAN',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'PAITAN NORTE',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'PAITAN SUR',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'PIGLISAN',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'PUGO',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'SABIT',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'SALAGUSOG',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'SINIMBAAN',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'TAGTAGUMBAO',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'TUTULOY',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'UNGAB',
    },
    {
        CITY: 'CUYAPO',
        BARANGAY: 'VILLAFLORES',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'BAGTING',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'BITULOK (NORTH POB.)',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'BUGNAN',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'CALABASA',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'CAMACHILE',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'CUYAPA',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'LIGAYA',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'MACASANDAL',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'PANTOC',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'PINAMALISAN',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'SAWMILL',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'GABALDON',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'BALANTE',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'BAYANIHAN',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'BULAK',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'BUNGO',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'KAPALANGAN',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'MABUNGA',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'MABURAK',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'MAHIPON',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'MAKABACLAY',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'MALIMBA',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'MANGINO',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'MARELO',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'PAMBUAN',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'PARCUTELA',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'PUTING TUBIG',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'SAN LORENZO (POB.)',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'SANTO CRISTO NORTE',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'SANTO CRISTO SUR',
    },
    {
        CITY: 'GAPAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'BALANGKARE NORTE',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'BALANGKARE SUR',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'BALARING',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'BELEN',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'BRAVO',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'BUROL',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'KABULIHAN',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'MAG-ASAWANG SAMPALOC',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'MANAROG',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'MATAAS NA KAHOY',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'PANACSAC',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'PICALEON',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'PINAHAN',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'PLATERO',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'PULA',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'PULONG SINGKAMAS',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'SAPANG BATO',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'TALABUTAB NORTE',
    },
    {
        CITY: 'GENERAL-MAMERTO-NATIVIDAD',
        BARANGAY: 'TALABUTAB SUR',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'BAGO',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'NAZARETH',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'PADOLINA',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'PALALE',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'PIAS',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'POBLACION CENTRAL',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'PULONG MATONG',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'RIO CHICO',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'GENERAL-TINIO',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'AGCANO',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'AYOS LOMBOY',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'BACAYAO',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'BAGONG BARRIO',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'BALBALINO',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'BALINGOG EAST',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'BALINGOG WEST',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'BANITAN',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'BULAKID',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'BUNOL',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CABALLERO',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CAINGIN TABING ILOG',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CALEM',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CAMILING',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CARDINAL',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CASONGSONG',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CATIMON',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CAVITE',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CAWAYAN BUGTONG',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CONSUELO',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'CULONG',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'ESCANO',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'FAIGAL',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'GALVAN',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'GUISET',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'LAMORITO',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'LENNEC',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'MACAMIAS',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'MACAPABELLAG',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'MACATCATUIT',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'MANACSAC',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'MANGGANG MARIKIT',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'MATURANOC',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'MAYBUBON',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'NAGLABRAHAN',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'NAGPANDAYAN',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'NARVACAN I',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'NARVACAN II',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'PACAC',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'PARTIDA I',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'PARTIDA II',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'PASONG INCHIC',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SAINT JOHN DISTRICT (POB.)',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SAN BERNARDINO',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SAN MARCELINO',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SANTA VERONICA DISTRICT (POB.)',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SANTO CRISTO DISTRICT (POB.)',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SARANAY DISTRICT (POB.)',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SINULATAN',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'SUBOL',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'TAMPAC I',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'TAMPAC II & III',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'TRIALA',
    },
    {
        CITY: 'GUIMBA',
        BARANGAY: 'YUSON',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'ANTONINO (POB.)',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'CALABASA',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'DAMPULAN (POB.)',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'DON MARIANO MARCOS (POB.)',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'HILERA',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'IMBUNIA',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'IMELDA POB. (DONA AURORA)',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'LAMBAKIN',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'LANGLA',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'MAGSALISI',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'MALABON-KAINGIN',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'MARAWA',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'NIYUGAN',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'OCAMPO-RIVERA DISTRICT (POB.)',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'PAKOL',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'PAMACPACAN',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'PINANGGAAN',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'PUTLOD',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'SAN JOSEF (NABAO)',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'SANTO TOMAS NORTH',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'SANTO TOMAS SOUTH',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'SAPANG',
    },
    {
        CITY: 'JAEN',
        BARANGAY: 'ULANIN-PITAK',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'BETANIA',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'CANANTONG',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'NAUZON',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'PANGARULONG',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'PINAGBAYANAN',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'SAGANA',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'SAN JOSEF',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LAUR',
        BARANGAY: 'SICLONG',
    },
    {
        CITY: 'LICAB',
        BARANGAY: 'AQUINO',
    },
    {
        CITY: 'LICAB',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'LICAB',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'LICAB',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'LICAB',
        BARANGAY: 'SAN CASIMIRO',
    },
    {
        CITY: 'LICAB',
        BARANGAY: 'SAN CRISTOBAL',
    },
    {
        CITY: 'LICAB',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LICAB',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'LICAB',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'LICAB',
        BARANGAY: 'TABING ILOG',
    },
    {
        CITY: 'LICAB',
        BARANGAY: 'VILLAROSA',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'A. BONIFACIO',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'BAGUMBAYAN (POB.)',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'BOSQUE',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'CARIDAD NORTE',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'CARIDAD SUR',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'CASILE',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'FLORIDA BLANCA',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'GENERAL RICARTE',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'GOMEZ',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'INANAMA',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'LIGAYA',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'MURCON',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'LLANERA',
        BARANGAY: 'VILLA VINIEGAS',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'AGUPALO ESTE',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'AGUPALO WESTE',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'ALALAY CHICA',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'ALALAY GRANDE',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'BAGONG FLORES',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'BALBALUNGAO',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'CORDERO',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'J. U. TIENZO (ARIMAL)',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'MAPANGPANG',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'NAMULANDAYAN',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'PARISTA',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'SALVACION I',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'SALVACION II',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'SAN ANTONIO ESTE',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'SAN ANTONIO WESTE',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LUPAO',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'ALEMANIA',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'AMBASADOR ALZATE VILLAGE',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'CABADUCAN EAST (POB.)',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'CABADUCAN WEST (POB.)',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'CABAWANGAN',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'EAST CENTRAL POBLACION',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'EDY',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'ESTACION (POB.)',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'MAELING',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'MAYANTOC',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'MEDICO',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'MONIC',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'NORTHWEST POBLACION',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'RECUERDO',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'SOUTH CENTRAL POBLACION',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'SOUTHEAST POBLACION',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'SOUTHWEST POBLACION',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'TONY',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'WEST CENTRAL POBLACION',
    },
    {
        CITY: 'NAMPICUAN',
        BARANGAY: 'WEST POBLACION',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BERTESE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DONA LUCIA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DULONG BAYAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ILOG BALIWAG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PULONG BAHAY',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN ALEJANDRO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN ANDRES I',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN ANDRES II',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTO TOMAS FERIA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'AGBANNAWAG',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'AGLIPAY (CURVA)',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'BICOS',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'CABUCBUCAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'CALAOCAN DISTRICT',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'CANAAN EAST',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'CANAAN WEST',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'CASILAGAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'ESTRELLA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'MACAPSING',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'PACO ROMAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'POBLACION CENTRAL',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'PORTAL',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SAN ESTEBAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'VILLA LABRADOR',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'VILLA PARAISO',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'BULIRAN',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'CAMA JUAN',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'JULO',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'LAWANG KUPANG',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'LUYOS',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'MAUGAT',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'PANABINGAN',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'PAPAYA',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAN MARIANO',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'TIKIW',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'ALUA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CALABA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MALAPIT',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MANGGA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'PULO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'TABON',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'BALOC',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'BUASAO',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'CASULUCAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'COMITANG',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'HULO',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'MALAYA (POOK MALAYA)',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'MALAYANTOC',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'MAMBARAO',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'PULONG BULI',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAGABA',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN FABIAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'ATATE',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'AULO',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'BAGONG BUHAY',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'BO. MILITAR (FORT MAGSAYSAY)',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'CABALLERO',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'CAIMITO',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'DONA JOSEFA',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'GANADERIA',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'IMELDA VALLEY',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'LANGKA',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'MALATE (POB.)',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'MANACNAC',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'MAPAIT',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'MARCOS VILLAGE',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'PALALE',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'POPOLON PAGAS',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'SANTOLAN',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'SAPANG BUHO',
    },
    {
        CITY: 'PALAYAN',
        BARANGAY: 'SINGALAT',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'CADACLAN',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'CAMBITALA',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'CONVERSION',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'GANDUZ',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'LIBERTY',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'MALBANG',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'MARIKIT',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'NAPON-NAPON',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PANTABANGAN',
        BARANGAY: 'VILLARICA',
    },
    {
        CITY: 'PENARANDA',
        BARANGAY: 'CALLOS',
    },
    {
        CITY: 'PENARANDA',
        BARANGAY: 'LAS PINAS',
    },
    {
        CITY: 'PENARANDA',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'PENARANDA',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'PENARANDA',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'PENARANDA',
        BARANGAY: 'POBLACION IV',
    },
    {
        CITY: 'PENARANDA',
        BARANGAY: 'SAN JOSEF',
    },
    {
        CITY: 'PENARANDA',
        BARANGAY: 'SAN MARIANO (MAUGAT)',
    },
    {
        CITY: 'PENARANDA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'PENARANDA',
        BARANGAY: 'SINASAJAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'A. PASCUAL',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'ABAR 2ND',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'ABAR IST',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CAANAWAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CAMANACSACAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CANUTO RAMOS POB. (DISTRICT III)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CRISANTO SANCHEZ POB. (DISTRICT V)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CULAYLAY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'DIZOL',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'FERDINAND E. MARCOS POB. (DISTRICT II)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'KALIWANAGAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'KITA-KITA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MANICLA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PALESTINA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PARANG MANGGA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PINILI',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PORAIS',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'RAFAEL RUEDA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'RAFAEL RUEDA SR. POB. (DISTRICT I)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'RAYMUNDO EUGENIO POB. (DISTRICT IV)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN MAURICIO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SANTO NINO 1ST',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SANTO NINO 2ND',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SANTO NINO 3RD',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SIBUT',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SINIPIT BUBON',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TABULAC',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TAYABO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TONDOD',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TULAT',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'VILLA FLORESCA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'VILLA JOSON (PARILLA)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'VILLA MARINA',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'BONIFACIO DISTRICT (POB.)',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'BURGOS DISTRICT (POB.)',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'CASTELLANO',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'DIVERSION',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'MAGPAPALAYOC',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'MALLORCA',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'MAMBANGNAN',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'NIEVES',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'RIZAL DISTRICT (POB.)',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'SAN ANTON',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'SAN BARTOLOME (POB.)',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'TABUATING',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'SAN-LEONARDO',
        BARANGAY: 'TAMBO ADORABLE',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'BERANG',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'COJUANGCO (POB.)',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'GOMEZ',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'INSPECTOR',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'ISLA',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'LA FUENTE',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'LIWAYWAY',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'MALACANANG',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'MALIOLIO',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'MAPALAD',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'RAJAL CENTRO',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'RAJAL NORTE',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'RAJAL SUR',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'SAN JOSEP',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'SAN MARIANO',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'SAPSAP',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'SOLEDAD',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'TAGPOS',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'TRAMO',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'VALENZUELA (POB.)',
    },
    {
        CITY: 'SANTA-ROSA',
        BARANGAY: 'ZAMORA (POB.)',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'BALANTE',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'BICAL',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'CABISUCULAN',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'CALABALABAAN',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'CALISITAN',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'CATALANACAN',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'CURVA',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'FRANZA',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'GABALDON',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'LABNEY',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'LICAONG',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'LINGLINGAY',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'MAGTANGGOL',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'MANGANDINGAY',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'MAPANGPANG',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'MARAGOL',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'MATINGKIS',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'NAGLABRAHAN',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'PALUSAPIS',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'PANDALLA',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'RANG-AYAN',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'SAPANG CAWAYAN',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'VILLA CUIZON',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'VILLA ISLA',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'VILLA NATI',
    },
    {
        CITY: 'SCIENCE-OF-MUNOZ',
        BARANGAY: 'VILLA SANTOS',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'ANDAL ALINO (POB.)',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BAKAL I',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BAKAL II',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BAKAL III',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BALUGA',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BANTUG HACIENDA',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BANTUG HAMOG (BASANG HAMOG)',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BUGTONG NA BULI',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BULAC',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'BURNAY',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'CAANIPLAHAN',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'CABUBULAONAN',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'CALIPAHAN',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'CAMPOS',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'CAPUTICAN',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'CASULUCAN ESTE',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'COLLADO',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'DIMASALANG NORTE',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'DIMASALANG SUR',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'DINARAYAT',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'ESGUERRA DISTRICT (POB.)',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'GULOD',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'HOMESTEAD I',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'HOMESTEAD II',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'KINALANGUYAN',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'LA TORRE',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'MAESTRANG KIKAY (POB.)',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'MAMANDIL',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'MARCOS DISTRICT (POB.)',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'MATINGKIS',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'MINABUYOC',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'PAG-ASA (POB.)',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'PALUDPOD',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'PANTOC BULAC',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'PINAGPANAAN',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'PULA',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'PULONG SAN MIGUEL (POB.)',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'PUROK MATIAS (POB.)',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'SAN MIGUEL NA MUNTI',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'SAN RICARDO',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'SIBUL',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'SICSICAN MATANDA',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'TABACAO',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'TALAVERA',
        BARANGAY: 'VALLE',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'ALULA',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'BAYBAYABAS',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'BUTED',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'CABIANGAN',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'CALISITAN',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'CINENSE',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'CULIAT',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'MAGSAYSAY (POB.)',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'MAYAMOT I',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'MAYAMOT II',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'NANGABULAN',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'OSMENA (POB.)',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'PANGIT',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'PATOLA',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'QUEZON (POB.)',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'QUIRINO (POB.)',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'ROXAS (POB.)',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'SAGUING',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'SARINGAYA',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'SAVERONA',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'TANDOC',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'TIBAG',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'VILLA BOADO',
    },
    {
        CITY: 'TALUGTUG',
        BARANGAY: 'VILLA ROSARIO',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'BATITANG',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'H. ROMERO',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'MACARSE',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'MANAUL',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'MAYAMOT',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'PANTOC',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'SANTA LUCIA OLD',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'SANTA LUCIA YOUNG',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'SANTO ROSARIO OLD',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'SANTO ROSARIO YOUNG',
    },
    {
        CITY: 'ZARAGOZA',
        BARANGAY: 'VALERIANA',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'BAGUINDOC (BAGUINLOC)',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'BANTOG',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'CAMPOS',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'CASILI',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'DON RAMON',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'HERNANDO',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'SAN FRANCISCO EAST',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'SAN FRANCISCO WEST',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'SAN JOSE NORTH',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'SAN JOSE SOUTH',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'SINENSE',
    },
    {
        CITY: 'ANAO',
        BARANGAY: 'SUAVERDEZ',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'ANUPUL',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'BANABA',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'BANGCU',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'CULUBASA',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'DELA CRUZ',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'MALONZO',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BAMBAN',
        BARANGAY: 'VIRGEN DE LOS REMEDIOS (PACALCAL)',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'ANOLING 1ST',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'ANOLING 2ND',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'ANOLING 3RD',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'BACABAC',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'BACSAY',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'BANCAY 1ST',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'BANCAY 2ND',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'BILAD',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'BIRBIRA',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'BOBON 1ST',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'BOBON 2ND',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'BOBON CAAROSIPAN',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'CABANABAAN',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'CACAMILINGAN NORTE',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'CACAMILINGAN SUR',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'CANIAG',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'CARAEL',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'CAYAOAN',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'CAYASAN',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'FLORIDA',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'LASONG',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'LIBUEG',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'MALACAMPA',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'MANAKEM',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'MANUPEG',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'MARAWI',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'MATUBOG',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'NAGRAMBACAN',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'NAGSERIALAN',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'PALIMBO PROPER',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'PALIMBO-CAAROSIPAN',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'PAO 1ST',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'PAO 2ND',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'PAO 2ND',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'PAO 3RD',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'PAPAAC',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'PINDANGAN 1ST',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'PINDANGAN 2ND',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'POBLACION A',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'POBLACION B',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'POBLACION C',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'POBLACION D',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'POBLACION E',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'POBLACION F',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'POBLACION G',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'POBLACION H',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'POBLACION J',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'SAWAT',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'SINILIAN 1ST',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'SINILIAN 2ND',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'SINILIAN 3RD',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'SINILIAN CACALIBOSOAN',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'SINULATAN 1ST',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'SINULATAN 2ND',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'SURGUI 1ST',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'SURGUI 2ND',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'SURGUI 3RD',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'TAMBUGAN',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'TELBANG',
    },
    {
        CITY: 'CAMILING',
        BARANGAY: 'TUEC',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'ARANGUREN',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'BUENO',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'CRISTO REY',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'CUBCUB (POB.)',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'CUTCUT 1ST',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'CUTCUT 2ND',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'ESTRADA (CALINGCUAN)',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'LAWY',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'MANLAPIG',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'MARUGLU',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'O\'DONELL',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'O\'DONNELL',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'SANTA JULIANA',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'SANTO DOMINGO 1ST',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'SANTO DOMINGO 2ND',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'CAPAS',
        BARANGAY: 'TALAGA',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'ABAGON',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'AMACALAN',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'APSAYAN',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'AYSON',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'BAWA',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'BUENLAG',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'BULARIT',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'CALAYAAN',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'CARBONEL',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'CARDONA',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'CATURAY',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'DANZO',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'DICOLOR',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'DON BASILIO',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'MAGASPAC',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'MALAYEP',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'MATAPITAP',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'MATAYUMCAB',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'NEW SALEM',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'OLOYBUAYA',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'PADAPADA',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'PARSOLINGAN',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'PINASLING (PINASUNG)',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'PLASTADO',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'SALAPUNGAN',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'SAN BARTOLOME',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'SEMBRANO',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'SINGAT',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'SULIPA',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'TAGUMBAO',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'TANGCARAN',
    },
    {
        CITY: 'GERONA',
        BARANGAY: 'VILLA PAZ',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'AMBALINGIT',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'BAYBAYAOAS',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'BIGBIGA',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'BINBINACA',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'CALABTANGAN',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'CAOCAOAYAN',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'CARABAOAN',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'CUBCUB',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'GAYONGGAYONG',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'GOSSOOD',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'LABNEY',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'MAMONIT',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'MANINIOG',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'MAPANDAN',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'NAMBALAN',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'PEDRO L. QUINES',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'PITOMBAYOG',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'ROTROTTOOC',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'SAN BARTOLOME',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'TALDIAPAN',
    },
    {
        CITY: 'MAYANTOC',
        BARANGAY: 'TANGCARANG',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'ABLANG-SAPANG',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'ARINGIN',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'ATENCIO',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'BANAOANG EAST',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'BANAOANG WEST',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'BAQUERO NORTE',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'BAQUERO SUR',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'CALAMAY',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'CALAPAN',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'CAMANGAAN EAST',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'CAMANGAAN WEST',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'CAMPOSANTO 1 - NORTE',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'CAMPOSANTO 1 - SUR',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'CAMPOSANTO 2',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'CAPAOAYAN',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'LAPSING',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'MALUAC',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'POBLACION 4',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'SAN LEON',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'SANTA LUCIA EAST',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'SANTA LUCIA WEST',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'TOLEGA NORTE',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'TOLEGA SUR',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'TUBECTUBANG',
    },
    {
        CITY: 'MONCADA',
        BARANGAY: 'VILLA',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'ABOGADO',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'ACOCOLAO',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'ADUAS',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'APULID',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'BALAOANG',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'BARANG (BORANG)',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'BRILLANTE',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'CABAYAOASAN',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'CANAN',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'CARINO',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'CAYANGA',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'COLIBANGBANG',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'CORAL',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'ESTACION',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'MABILANG',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'MANAOIS',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'MATALAPITAP',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'NAGMISAAN',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'NANCAMARINAN',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'NIPACO',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'PATALAN',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'RANG-AYAN',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'SALUMAGUE',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'SAMPUT',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'SAN JUAN DE MILLA',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'SINIGPIT',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'TABLANG',
    },
    {
        CITY: 'PANIQUI',
        BARANGAY: 'VENTENILLA',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'CADANGLAAN',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'ESTIPONA',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'MATINDEG',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'MAUNGIB',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'NAYA',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'NILASIN 1ST',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'NILASIN 2ND',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'POROC',
    },
    {
        CITY: 'PURA',
        BARANGAY: 'SINGAT',
    },
    {
        CITY: 'RAMOS',
        BARANGAY: 'CORAL-ILOCO',
    },
    {
        CITY: 'RAMOS',
        BARANGAY: 'GUITEB',
    },
    {
        CITY: 'RAMOS',
        BARANGAY: 'PANCE',
    },
    {
        CITY: 'RAMOS',
        BARANGAY: 'POBLACION CENTER',
    },
    {
        CITY: 'RAMOS',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'RAMOS',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'RAMOS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'RAMOS',
        BARANGAY: 'SAN RAYMUNDO',
    },
    {
        CITY: 'RAMOS',
        BARANGAY: 'TOLEDO',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'BALLOC',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'BAMBAN',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'CASIPO',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'CATAGUDINGAN',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'DALDALAYAP',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'DOCLONG 1',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'DOCLONG 2',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'NAGSABARAN',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'PIT-AO',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'SAN-CLEMENTE',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'BALDIOS',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'BOTBOTONES',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'CAANAMONGAN',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'CABUGBUGAN',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'CADULDULAOAN',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'CALIPAYAN',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'MACAGUING',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'NAMBALAN',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'PADAPADA',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'PILPILA',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'PINPINAS',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'PUGO-CECILIO',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'SAN SOTERO',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'SANTA INES CENTRO',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'SANTA INES EAST',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'SANTA INES WEST',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'TAGUIPORO',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'TIMMAGUAB',
    },
    {
        CITY: 'SANTA-IGNACIA',
        BARANGAY: 'VARGAS',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'AGUSO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'ALVINDIA SEGUNDO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'AMUCAO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'ARMENIA',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'ASTURIAS',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'ATIOC',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BALANTI',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BALETE',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BALIBAGO I',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BALIBAGO II',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BALINGCANAWAY',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BANABA',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BANTOG',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BARAS-BARAS',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BATANG-BATANG',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BINAUGANAN',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BORA',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BUHILIT (BUBULIT)',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'BUROT',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'CALINGCUAN',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'CAPEHAN',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'CARANGIAN',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'CARE',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'CENTRAL',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'CULIPAT',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'CUT-CUT I',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'CUT-CUT II',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'DALAYAP',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'DELA PAZ',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'LAOANG',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'LIGTASAN',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'MALIWALO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'MAPALACSIAO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'MAPALAD',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'MATADERO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'MATATALAIB',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SALAPUNGAN',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN JOSE DE URQUICO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN JUAN DE MATA',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SANTA CRUZ (ALVINDIA PRIMERO)',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAPANG MARAGUL',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SAPANG TAGALOG',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SEPUNG CALZADA',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SINAIT',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'SUIZO',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'TARIJI',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'TIBAG',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'TIBAGAN',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'TRINIDAD (TRINIDAD PRIMERO)',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'UNGOT',
    },
    {
        CITY: 'TARLAC',
        BARANGAY: 'VILLA BACOLOR',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'ALFONSO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'BALUTU',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'CAFE',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'CALIUS GUECO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'CALULUAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'CASTILLO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'CORAZON DE JESUS',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'CULATINGAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'DUNGAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'DUTUNG-A-MATAS',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'GREEN VILLAGE',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'LILIBANGAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MABILOG',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MAGAO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MALUPA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MINANE',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'PANALICSIAN (PANALICSICAN)',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'PANDO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'PARANG',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'PARULUNG',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'PITABUNAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN AGUSTIN (MURCIA)',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN BARTOLOME',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN ISIDRO (ALMENDRAS)',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN JUAN (CASTRO)',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN MARTIN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN NICOLAS BALAS',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN VICENTE (CALUIS/COBRA)',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SANTO ROSARIO (MAGUNTING)',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'TALIMUNDUC MARIMLA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'TALIMUNDUC SAN MIGUEL',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'TELABANCA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'TINANG',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'BALANOY',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'BANTOG-CARICUTAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'CARAMUTAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'CAUT',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'COMILLAS',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'DUMARAIS',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'GUEVARRA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'KAPANIKIAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'LA PURISIMA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'LARA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'LAUNGCUPANG',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'MACALONG',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'MATAYUMTAYUM',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'MAYANG',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'MOTRICO',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'PALUDPUD',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'SIERRA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'DAVID',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'IBA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LABNEY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LAWACAMULAG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LUBIGAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MAAMOT',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MABABANABA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MORIONES',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PAO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN JUAN DE VALDEZ',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SULA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'VILLA AGLIPAY',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'COLUBOT',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'LANAT',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'LEGASPI',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'MANGANDINGAY',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'MATARANNOC',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'PACPACO',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SALCEDO',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN JACINTO',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN NARCISO',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BACULONG',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BALAYANG',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BALBALOTO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BANGAR',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BANTOG',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BATANGBATANG',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BULO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'CABULUAN',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'CALIBUNGAN',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'CANAREM',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'CRUZ',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'LALAPAC',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'MALUID',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'MANGOLAGO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'MASALASA',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'PALACPALAC',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN FERNANDO (POB.)',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN GAVINO (POB.)',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN JACINTO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SANTA LUCIA (POB.)',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'BANABAN',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'BINAGBAG',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'DONACION',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'ENCANTO',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'LAOG',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'MARUNGKO',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'NIUGAN',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'PALTOK',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'PULONG YANTOK',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'SANTO CRISTO (POB.)',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'SULUCAN',
    },
    {
        CITY: 'ANGAT',
        BARANGAY: 'TABOC',
    },
    {
        CITY: 'BALAGTAS',
        BARANGAY: 'BOROL 1ST',
    },
    {
        CITY: 'BALAGTAS',
        BARANGAY: 'BOROL 2ND',
    },
    {
        CITY: 'BALAGTAS',
        BARANGAY: 'DALIG',
    },
    {
        CITY: 'BALAGTAS',
        BARANGAY: 'LONGOS',
    },
    {
        CITY: 'BALAGTAS',
        BARANGAY: 'PANGINAY',
    },
    {
        CITY: 'BALAGTAS',
        BARANGAY: 'PULONG GUBAT',
    },
    {
        CITY: 'BALAGTAS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BALAGTAS',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'BALAGTAS',
        BARANGAY: 'WAWA (POB.)',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'BAGONG NAYON',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'BARANGCA',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'CALANTIPAY',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'CATULINAN',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'HINUKAY',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'MAKINABANG',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'MATANGTUBIG',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'PAGALA',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'PAITAN',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'PIEL',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'PINAGBARILAN',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'SUBIC',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'SULIVAN',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'TANGOS',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'TARCAN',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'TIAONG',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'TIBAG',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'TILAPAYONG',
    },
    {
        CITY: 'BALIUAG',
        BARANGAY: 'VIRGEN DELAS FLORES',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'ANTIPONA',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'BAMBANG',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'BATIA',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'BINANG 1ST',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'BINANG 2ND',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'BOLACAN',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'BUNDUKAN',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'BUNLO',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'CAINGIN',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'DUHAT',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'IGULOT',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'LOLOMBOY',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'SULUCAN',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'TAAL',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'TAMBOBONG',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'TURO',
    },
    {
        CITY: 'BOCAUE',
        BARANGAY: 'WAKAS',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'BALUBAD',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'BAMBANG',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'MATUNGAO',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'MAYSANTOL',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'PEREZ',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'PITPITAN',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'TALIPTIP',
    },
    {
        CITY: 'BULACAN',
        BARANGAY: 'TIBIG',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'ABULALAS',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'CARILLO',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'IBA',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'IBA-IBAYO',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'MERCADO',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'PALAPAT',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'PUGAD',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAGRADA FAMILIA',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'TAMPOK',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'TIBAGUIN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'AGNAYA',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'BANGA I',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'BANGA II',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'BINTOG',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'BULIHAN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'CULIANIN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'DAMPOL',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'LAGUNDI',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'LALANGAN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'LUMANG BAYAN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'PARULAN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'RUEDA',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'SIPAT',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'TABANG',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'AKLE',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'ALAGAO',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'ANYATAM',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'BAGONG BARRIO',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'BASUIT',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'BUBULONG MALAKI',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'BUBULONG MUNTI',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'BUHOL NA MANGGA',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'BULUSUKAN',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'CALASAG',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'CALAWITAN',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'CASALAT',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'GABIHAN',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'GARLANG',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'LAPNIT',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'MAASIM',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'MAKAPILAPIL',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'MALIPAMPANG',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'MATAAS NA PARANG',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'MATIMBUBONG',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'NABAONG GARLANG',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'PALAPALA',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'PASONG BANGKAL',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'PINAOD',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'PULONG TAMO',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'SANTA CATALINA BATA',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'SANTA CATALINA MATANDA',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'SAPANG DAYAP',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'SAPANG PUTIK',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'SAPANG PUTOL',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'SUMANDIG',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'TELEPATIO',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'UMPUCAN',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'UPIG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BAGONG PAG-ASA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BALAONG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BANTOG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BARDIAS',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BARITAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BATASAN BATA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BATASAN MATANDA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BIAK-NA-BATO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BICLAT',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BUGA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BULIRAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BULUALTO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CAMBIO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CAMIAS',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'ILOG-BULO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'KING KABAYO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'LABNE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'LAMBAKIN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MAGMARALE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MALIBAY',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MANDILE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MASALIPIT',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PACALAG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PALIWASAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PARTIDA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PINAMBARAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PULONG BAYABAS',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PULONG DUHAT',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SACDALAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SALACOT',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SALANGAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTA RITA BATA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTA RITA MATANDA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAPANG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SIBUL',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'TARTARO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'TIBAGAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'TIGPALAS',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'BANCA-BANCA',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'BMA-BALAGTAS',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'CAINGIN',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'CAPIHAN',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'CORAL NA BATO',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'CRUZ NA DAAN',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'DAGAT-DAGATAN',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'DILIMAN I',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'DILIMAN II',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'LIBIS',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'LICO',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'MAASIM',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'MABALAS-BALAS',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'MAGUINAO',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'MARONGUILLO',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'PACO',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'PANSUMALOC',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'PANTUBIG',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'PASONG BANGKAL',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'PASONG CALLOS',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'PASONG INTSIK',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'PINACPINACAN',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'PULO',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'PULONG BAYABAS',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'SALAPUNGAN',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'SAPANG PAHALANG',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'TALACSAN',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'TAMBUBONG',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'TUKOD',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'ULINGAO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BAGBAGUIN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BALASING',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BULAC',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CAMANGYANAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CAY POMBO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CAYSIO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'GUYONG',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'LALAKHAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MAG-ASAWANG SAPA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MAHABANG PARANG',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MANGGAHAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'PARADA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'PULONG BUHANGIN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN JOSE PATAG',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SILANGAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'TABING BAKOD',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'TUMANA',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'BONGA MAYOR',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'BONGA MENOR',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'BUISAN',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'CAMACHILIHAN',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'CAMBAOG',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'CATACTE',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'LICIADA',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'MALAMIG',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'MALAWAK',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'TALAMPAS',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'TANAWAN',
    },
    {
        CITY: 'BUSTOS',
        BARANGAY: 'TIBAGAN',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'BALUNGAO',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'BUGUION',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'BULUSAN',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'CALIZON',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'CANIOGAN',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'CORAZON',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'FRANCES',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'GATBUCA',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'GUGO',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'IBA ESTE',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'IBA O\'ESTE',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'LONGOS',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'MEYSULAO',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'MEYTO',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'PALIMBANG',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'PANDUCOT',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'PIO CRUZCOSA',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'PUNGO',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'SAPANG BAYAN',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'SERGIO BAYAN',
    },
    {
        CITY: 'CALUMPIT',
        BARANGAY: 'SUCOL',
    },
    {
        CITY: 'DONA-REMEDIOS-TRINIDAD',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'DONA-REMEDIOS-TRINIDAD',
        BARANGAY: 'CAMACHILE',
    },
    {
        CITY: 'DONA-REMEDIOS-TRINIDAD',
        BARANGAY: 'CAMACHIN',
    },
    {
        CITY: 'DONA-REMEDIOS-TRINIDAD',
        BARANGAY: 'KABAYUNAN',
    },
    {
        CITY: 'DONA-REMEDIOS-TRINIDAD',
        BARANGAY: 'KALAWAKAN',
    },
    {
        CITY: 'DONA-REMEDIOS-TRINIDAD',
        BARANGAY: 'PULONG SAMPALOK',
    },
    {
        CITY: 'DONA-REMEDIOS-TRINIDAD',
        BARANGAY: 'SAPANG BULAK',
    },
    {
        CITY: 'DONA-REMEDIOS-TRINIDAD',
        BARANGAY: 'TALBAK',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'CUTCUT',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'DAUNGAN',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'ILANG-ILANG',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'MALIS',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'PANGINAY',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'PRITIL',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'PULONG GUBAT',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'TABANG',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'TABE',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'TIAONG',
    },
    {
        CITY: 'GUIGUINTO',
        BARANGAY: 'TUKTUKAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'ANILAO',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'ATLAG',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'BABATNIN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'BAGNA',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'BAGONG BAYAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'BALAYONG',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'BANGKAL',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'BARIHAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'BULIHAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'BUNGAHAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'CAINGIN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'CALERO',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'CALILIGAWAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'CANALATE',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'CANIOGAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'COFRADIA',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'DAKILA',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'GUINHAWA',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'LIGAS',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'LIYANG',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'LONGOS',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'LOOK 1ST',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'LOOK 2ND',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'LUGAM',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'MABOLO',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'MAMBOG',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'MASILE',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'MATIMBO',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'MOJON',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'NAMAYAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'NIUGAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'PAMARAWAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'PANASAHAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'PINAGBAKAHAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SANTISIMA TRINIDAD',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SANTO ROSARIO (POB.)',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SUMAPANG BATA',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'SUMAPANG MATANDA',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'TAAL',
    },
    {
        CITY: 'MALOLOS',
        BARANGAY: 'TIKAY',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'ABANGAN NORTE',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'ABANGAN SUR',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'IBAYO',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'LAMBAKIN',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'LIAS',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'LOMA DE GATO',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'NAGBALON',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'PATUBIG',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'PRENZA I',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'PRENZA II',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'SANTA ROSA I',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'SANTA ROSA II',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'SAOG',
    },
    {
        CITY: 'MARILAO',
        BARANGAY: 'TABING ILOG',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'BAGBAGUIN',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'BAHAY PARE',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'BANCAL',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'BANGA',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'BAYUGO',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'CAINGIN',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'CALVARIO',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'CAMALIG',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'HULO',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'IBA',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'LANGKA',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'LAWA',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'LIBTONG',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'LIPUTAN',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'LONGOS',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'MALHACAN',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'PAJO',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'PANDAYAN',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'PANTOC',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'PEREZ',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'SAINT FRANCIS (GASAK)',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'SALUYSOY',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'TUGATOG',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'UBIHAN',
    },
    {
        CITY: 'MEYCAUAYAN',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'BANGKAL',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'BARAKA',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'BIGTE',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'BITUNGOL',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'FRIENDSHIP VILLAGE RESOURCES (FVR)',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'MATICTIC',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'MINUYAN',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'PARTIDA',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'PINAGTULAYAN',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'NORZAGARAY',
        BARANGAY: 'TIGBE',
    },
    {
        CITY: 'OBANDO',
        BARANGAY: 'BINUANGAN',
    },
    {
        CITY: 'OBANDO',
        BARANGAY: 'CATANGHALAN',
    },
    {
        CITY: 'OBANDO',
        BARANGAY: 'HULO',
    },
    {
        CITY: 'OBANDO',
        BARANGAY: 'LAWA',
    },
    {
        CITY: 'OBANDO',
        BARANGAY: 'PACO',
    },
    {
        CITY: 'OBANDO',
        BARANGAY: 'PAG-ASA (POB.)',
    },
    {
        CITY: 'OBANDO',
        BARANGAY: 'PALIWAS',
    },
    {
        CITY: 'OBANDO',
        BARANGAY: 'PANGHULO',
    },
    {
        CITY: 'OBANDO',
        BARANGAY: 'SALAMBAO',
    },
    {
        CITY: 'OBANDO',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'OBANDO',
        BARANGAY: 'TAWIRAN',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'BAGBAGUIN',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'BAGONG BARRIO',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'BAKA-BAKAHAN',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'BUNSURAN I',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'BUNSURAN II',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'BUNSURAN III',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'CACARONG BATA',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'CACARONG MATANDA',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'CUPANG',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'MALIBONG BATA',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'MALIBONG MATANDA',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'MANATAL',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'MAPULANG LUPA',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'MASAGANA',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'MASUSO',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'PINAGKUARTELAN',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'REAL DE CACARONG',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'SILING BATA',
    },
    {
        CITY: 'PANDI',
        BARANGAY: 'SILING MATANDA',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'BINAKOD',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'KAPITANGAN',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'MALUMOT',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'MASUKOL',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'PINALAGDAN',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'SAN ISIDRO I',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'SAN ISIDRO II',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PAOMBONG',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'BALATONG A',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'BALATONG B',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'CUTCOT',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'DAMPOL I',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'DAMPOL II-A',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'DAMPOL II-B',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'DULONG MALABON',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'INAON',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'LONGOS',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'PALTAO',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'PENABATAN',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'SANTA PEREGRINA',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'TAAL',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'TABON',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'TIBAG',
    },
    {
        CITY: 'PULILAN',
        BARANGAY: 'TINEJERO',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'ASSUMPTION',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'BAGONG BUHAY',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'BAGONG BUHAY II',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'BAGONG BUHAY III',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'CITRUS',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'CIUDAD REAL',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'DULONG BAYAN',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'FATIMA II',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'FATIMA III',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'FATIMA IV',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'FATIMA V',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'FRANCISCO HOMES-GUIJO',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'FRANCISCO HOMES-MULAWIN',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'FRANCISCO HOMES-NARRA',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'FRANCISCO HOMES-YAKAL',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'GAYA-GAYA',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'GRACEVILLE',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'GUMAOC CENTRAL',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'GUMAOC EAST',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'GUMAOC WEST',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'KAYBANBAN',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'KAYPIAN',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'LAWANG PARI',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'MAHARLIKA',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'MINUYAN',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'MINUYAN II',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'MINUYAN III',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'MINUYAN IV',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'MINUYAN PROPER',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'MINUYAN V',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'MUZON',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'MUZON',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'PARADISE III',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN MARTIN',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN MARTIN II',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN MARTIN III',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN MARTIN IV',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN RAFAEL I',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN RAFAEL III',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN RAFAEL IV',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN RAFAEL V',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SANTA CRUZ II',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SANTA CRUZ III',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SANTA CRUZ IV',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SANTA CRUZ V',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SANTO NINO II',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'SAPANG PALAY',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'ST. MARTIN DE PORRES',
    },
    {
        CITY: 'SAN-JOSE-DEL-MONTE',
        BARANGAY: 'TUNGKONG MANGGA',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'AGAPITO DEL ROSARIO',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'AMSIC',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'ANUNAS',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'BALIBAGO',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'CAPAYA',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'CLARO M. RECTO',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'CUAYAN',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'CUTCUT',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'CUTUD',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'LOURDES NORTH WEST',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'LOURDES SUR',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'LOURDES SUR EAST',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'MALABANIAS',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'MARGOT',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'MINING',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'NINOY AQUINO (MARISOL)',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'PAMPANG',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'PULUNG CACUTUD',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'PULUNG MARAGUL',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'PULUNGBULU',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'SALAPUNGAN',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'SANTA TRINIDAD',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'SANTO ROSARIO (POB.)',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'SAPALIBUTAD',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'SAPANGBATO',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'TABUN',
    },
    {
        CITY: 'ANGELES',
        BARANGAY: 'VIRGEN DELOS REMEDIOS',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'BALUCUC',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'CALANTIPE',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'CANSINALA',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'CAPALANGAN',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'COLGANTE',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'PALIGUI',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'SUCAD',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'SULIPAN',
    },
    {
        CITY: 'APALIT',
        BARANGAY: 'TABUYUC (SANTO ROSARIO)',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'ARENAS',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'BALITI',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'BATASAN',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'BUENSUCESO',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'CANDATING',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'CUPANG (SANTA LUCIA)',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'GATIAWIN',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'GUEMASAN',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'KALEDIAN (CAMBA)',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'LA PAZ (TURU)',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'LACMIT',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'LACQUIOS',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'MANGGA-CACUTUD',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'MAPALAD',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'MATAMO (SANTA LUCIA)',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'PANLINLANG',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'PARALAYA',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'PLAZANG LUMA',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'SAN AGUSTIN NORTE',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'SAN AGUSTIN SUR',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'SAN JOSE MESULO',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'SAN JUAN BANO',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'SAN ROQUE BITAS',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'SANTO NINO TABUAN',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'SUCLAYIN',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'TELAPAYONG',
    },
    {
        CITY: 'ARAYAT',
        BARANGAY: 'TELAPAYONG',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'BALAS',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'CABALANTIAN',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'CABAMBANGAN (POB.)',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'CABETICAN',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'CALIBUTBUT',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'DUAT',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'MACABACLE',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'MAGLIMAN',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'MALIWALU',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'MESALIPIT',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'PARULOG',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'POTRERO',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'TALBA',
    },
    {
        CITY: 'BACOLOR',
        BARANGAY: 'TINAJERO',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'BAHAY PARE',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'BAMBANG',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'BARANGCA',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'BARIT',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'BUAS (POB.)',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'CUAYANG BUGTONG',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'DALAYAP',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'DULONG ILOG',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'GULAP',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'LANANG',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'MAGUMBALI',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'MANDASIG',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'MANDILI',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'MANGGA',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'MAPANIQUI',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'PALIGUI',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'PANGCLARA',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'PANSINAO',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'PARALAYA (POB.)',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'PASIG',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'PESCADORES (POB.)',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'PULONG GUBAT',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'PULONG PALAZAN',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'SALAPUNGAN',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'SAN AGUSTIN (POB.)',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'TAGULOD',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'TALANG',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'TENEJERO',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'VIZAL SAN PABLO',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'VIZAL SANTO CRISTO',
    },
    {
        CITY: 'CANDABA',
        BARANGAY: 'VIZAL SANTO NINO',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'ANON',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'APALIT',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'BASA AIR BASE',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'BENEDICTO',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'BODEGA',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'CABANGCALAN',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'CALANTAS',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'CARMENCITA',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'CONSUELO',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'DAMPE',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'DEL CARMEN',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'FORTUNA',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'GUTAD',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'MABICAL',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'MAWACAT',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'NABUCLOD',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'PABANLAG',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'PAGUIRUAN',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'PALMAYO',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'PANDAGUIRIG',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'SANTO ROSARIO (MALABO)',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'SOLIB',
    },
    {
        CITY: 'FLORIDABLANCA',
        BARANGAY: 'VALDEZ',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'ASCOMO',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'BANCAL',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'JOSE ABAD SANTOS (SIRAN)',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'LAMBAC',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'MAQUIAPO',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'NATIVIDAD',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'PLAZA BURGOS (POB.)',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'PULUNGMASLE',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN JUAN BAUTISTA',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN JUAN NEPOMUCENO',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN MATIAS',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN MIGUEL (BETIS)',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN NICOLAS 1ST',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN NICOLAS 2ND',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN RAFAEL (DUCK ISLAND)',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SAN VICENTE (IBUS)',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SANTA FILOMENA (POB.)',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SANTA URSULA',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'GUAGUA',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'BALANTACAN',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'BANCAL PUGAD',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'BANCAL SINUBLI',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'BARUYA (SAN RAFAEL)',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'CALANGAIN',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'DE LA PAZ',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'DEL CARMEN',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'DON IGNACIO DIMSON',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'LOURDES (LAUC PAU)',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'PRADO SIONGCO',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'REMEDIOS',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN JOSE APUNAN',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN JOSE GUMI',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN MATIAS',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN NICOLAS 1ST (POB.)',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN NICOLAS 2ND',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN PABLO 1ST',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN PABLO 2ND',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN PEDRO PALCARANGAN',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN PEDRO SAUG',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN ROQUE ARBOL',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN ROQUE DAU',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTA LUCIA (POB.)',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTA TERESA 1ST',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTA TERESA 2ND',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTO NINO (PRADO ARUBA)',
    },
    {
        CITY: 'LUBAO',
        BARANGAY: 'SANTO TOMAS (POB.)',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'ATLU-BOLA',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'BICAL',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'BUNDAGUL',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'CACUTUD',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'CAMACHILES',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'DAU',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'DUQUIT',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'LAKANDULA',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'MABIGA',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'MACAPAGAL VILLAGE',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'MAMATITANG',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'MANGALIT',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'MARCOS VILLAGE',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'MAWAQUE',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'PARALAYUNAN',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'SAPANG BALEN',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'SAPANG BIABAS',
    },
    {
        CITY: 'MABALACAT',
        BARANGAY: 'TABUN',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'BATASAN',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'CADUANG TETE',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'CANDELARIA',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'CASTULI',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'CONSUELO',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'DALAYAP',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'MATAGUITI',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SAN ESTEBAN',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SAN GABRIEL (POB.)',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SANTA LUTGARDA',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SANTA RITA (POB.)',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SANTO ROSARIO (POB.)',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'SAPLAD DAVID',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'TACASAN',
    },
    {
        CITY: 'MACABEBE',
        BARANGAY: 'TELACSAN',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'AYALA',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'BUCANAN',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'CAMIAS',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'ESCALER',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'NAVALING',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN FRANCISO',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN ILDEFONSO',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN NICOLAS 1ST (POB.)',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN NICOLAS 2ND',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN PABLO (POB.)',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN PEDRO I',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN PEDRO II',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'MAGALANG',
        BARANGAY: 'TURU',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'ALAULI',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'BAGANG',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'BALIBAGO',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'BEBE ANAC',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'BEBE MATUA',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'BULACUS',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'CAMBASI',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'MALAULI',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'NIGUI',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'PALIMPE',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'PUTI',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SAGRADA (TIBAGIN)',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SAN AGUSTIN (CAINGIN)',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SAN ISIDRO ANAC',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SAN ISIDRO MATUA (POB.)',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SANTA LUCIA ANAC (POB.)',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SANTA LUCIA MATUA',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SANTA LUCIA PAGUIBA',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SANTA LUCIA WAKAS',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SANTA MONICA (CAINGIN)',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SAPANG KAWAYAN',
    },
    {
        CITY: 'MASANTOL',
        BARANGAY: 'SUA',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'ACLI',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'ANAO',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'BALAS',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'CAMUNING',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'CULUBASA',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'DOLORES (PIRING)',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'EDEN',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'GANDUS',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'LAGUNDI',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'LAPUT',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'LAUG',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'MASAMAT',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'MASANGSANG',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'NUEVA VICTORIA',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'PANDACAQUI',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'PANDACAQUI',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'PANGATLAN',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'PANIPUAN',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'PARIAN (POB.)',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SABANILLA',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN JOSE MALINO',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN JOSE MATULID',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN PATRICIO',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SAPANG MAISAC',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'SUCLABAN',
    },
    {
        CITY: 'MEXICO',
        BARANGAY: 'TANGLE (TANGLAY)',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'BULAC',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'DAWE',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'MANIANGO',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'SAN FRANCISCO 1ST',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'SAN FRANCISCO 2ND',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'SANTO ROSARIO (POB.)',
    },
    {
        CITY: 'MINALIN',
        BARANGAY: 'SAPLAD',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'ALASAS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BALITI',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BULAON',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CALULUT',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DEL CARMEN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DELA PAZ NORTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DELA PAZ SUR',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'JULIANA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'LARA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MAGLIMAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MAIMPIS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MALINO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MALPITIC',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PANDARAS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PANIPUAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PULUNG BULU',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'QUEBIAUAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAGUIN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SANTO ROSARIO (POB.)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SINDALAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TELABASTAGAN',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTA CRUZ PAMBILOG',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTA CRUZ POBLACION',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN BARTOLOME',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN JOAQUIN (POB.)',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'BECURAN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'DILA-DILA',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN BASILIO',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN MATIAS',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'MORAS DE LA PAZ',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN BARTOLOME',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN MATIAS',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SANTO ROSARIO (PAU)',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAPA (SANTO NINO)',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'BABO PANGULO',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'BABO SACAN',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'BALUBAD',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'CALZADANG BAYU',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'CAMIAS',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'CANGATBA',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'DIAZ',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'DOLORES (HACIENDA DOLORES)',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'INARARO (AETAS)',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'JALUNG',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'MANCATIAN',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'MANIBAUG LIBUTAD',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'MANIBAUG PARALAYA',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'MANIBAUG PASIG',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'MANUALI',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'MITLA PROPER',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'PALAT',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'PIAS',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'PIO',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'PLANAS',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'PULONG SANTOL',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'SALU',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'SAN JOSE MITLA',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'SAPANG UWAK (AETAS)',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'SEPUNG BULAUN',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'SINURA',
    },
    {
        CITY: 'PORAC',
        BARANGAY: 'VILLA MARIA (AETAS)',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'DE LA PAZ',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SAN PABLO LIBUTAD',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SAN PABLO PROPER',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'SAN-SIMON',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'BATANG 1ST',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'BATANG 2ND',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'MABUANBUAN',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'MALUSAC',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'SABITANAN',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'SAN NICOLAS 1ST',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'SAN NICOLAS 2ND',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'SANTA LUCIA (POB.)',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'SASMUAN',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BUHANGIN',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'CALABUANAN',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'OBLIGACION',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'PINGIT',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'RESERVA',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'SUCLAYIN',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'ZABALI',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DIAGYAN',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DICABASAN',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DILAGUIDI',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DIMASESET',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DINIOG',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'MALIGAYA (POB.)',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'MANGGITAHAN',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'MASAGANA (POB.)',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'ABULEG',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'DIBARAYBAY',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'DITAWINI',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'MAPALAD',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'NIPOO (BULO)',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'PALEG',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'SIMBAHAN',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'APLAYA',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'BUTAS NA BATO',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'CABOG (MATAWE)',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'CARAGSACAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'DAVILDAVILAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'DIKAPANIKIAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'IBONA',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'PALTIC',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'TANAWAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'UMIRAY (MALAMIG)',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'BORLONGAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIAMANEN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIANED',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIARABASIN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIBUTUNAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIMABUNO',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DINADIAWAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DITALE',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'GUPA',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'LABOY',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'LIPIT',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'LOBBOT',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'MIJARES',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'MUCDOL',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'PUANGI',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'SALAY',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'SAPANGKAWAYAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'TOYTOYAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'ALCALA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAGTU',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BANGCO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAUBO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAYANIHAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAZAL',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'CABITUCULAN EAST',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'CABITUCULAN WEST',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'CADAYACAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DEBUCAO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DETAILEN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIAAT',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIALATMAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIANAWAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIKILDIT',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIMANPUDSO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIOME',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'ESTONILO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'FLORIDA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'GALINTUJA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'QUIRINO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'RAMADA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN LEONARDO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SUGUIT',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'WENCESLAO',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'BANCAL',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'BANGAN',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'BATONLAPOC',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'BELBEL',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'BENEG',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'BINUCLUTAN',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'CABATUAN',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'CAPAYAWAN',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'CARAEL',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'DANACBUNGA',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'MAGUISGUIS',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'MALOMBOY',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'MAMBOG',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'MORAZA',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'NACOLCOL',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'OWAOG-NIBLOC',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'PACO (POB.)',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'PALIS',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'PANAN',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'PAREL',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'PAUDPOD',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'POONBATO',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'PORAC',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'TAMPO (POB.)',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'TAUGTOG',
    },
    {
        CITY: 'BOTOLAN',
        BARANGAY: 'VILLAR',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'APO-APO',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'AREW',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'BANUAMBAYO (POB.)',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'CADMANG-RESERVA',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'CAMILING (CAMIING)',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'CASABAAN',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'DEL CARMEN (POB.)',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'DOLORES (POB.)',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'FELMIDA-DIAZ',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'LAOAG',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'LONGOS',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'MABANGLIT',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'NEW SAN JUAN',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CABANGAN',
        BARANGAY: 'TONDO',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'BALAYBAY',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'NAGBAYAN',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'NAGBUNGA',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'SAN PABLO (POB.)',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CASTILLEJOS',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'AMUNGAN',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'BANGANTALINGA',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'DIRITA-BALOGUEN',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'LIPAY-DINGIN-PANIBUATAN',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'PALANGINAN (PALANGUINAN-TAMBAK)',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'ZONE 1 POB. (LIBABA)',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'ZONE 2 POB. (AYPA)',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'ZONE 3 POB. (BOTLAY)',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'ZONE 4 POB. (SAGAPAN)',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'ZONE 5 POB. (BANO)',
    },
    {
        CITY: 'IBA',
        BARANGAY: 'ZONE 6 POB. (BAYTAN)',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'BALOGANON',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'BAMBAN',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'BANI',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'COLLAT',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'INHOBOL',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'SAN SALVADOR',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'TALTAL',
    },
    {
        CITY: 'MASINLOC',
        BARANGAY: 'TAPUAC',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'ASINAN',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'BANICAIN',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'BARRETO',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'EAST BAJAC-BAJAC',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'EAST TAPINAC',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'GORDON HEIGHTS',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'KALAKLAN',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'MABAYUAN',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'NEW CABALAN',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'NEW ILALIM',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'NEW KABABAE',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'NEW KALALAKE',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'OLD CABALAN',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'WEST BAJAC-BAJAC',
    },
    {
        CITY: 'OLONGAPO',
        BARANGAY: 'WEST TAPINAC',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'ALWA',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'BULAWEN',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'CAUYAN',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'EAST POBLACION',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'GARRETA',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'LIBABA',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'LIOZON',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'LIPAY',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'LOCLOC',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'MACARANG',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'MAGALAWA',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'PANGOLINGAN',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'SALAZA',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'TITION (SAN VICENTE)',
    },
    {
        CITY: 'PALAUIG',
        BARANGAY: 'WEST POBLACION',
    },
    {
        CITY: 'SAN-FELIPE',
        BARANGAY: 'AMAGNA (POB.)',
    },
    {
        CITY: 'SAN-FELIPE',
        BARANGAY: 'APOSTOL (POB.)',
    },
    {
        CITY: 'SAN-FELIPE',
        BARANGAY: 'BALINCAGUING',
    },
    {
        CITY: 'SAN-FELIPE',
        BARANGAY: 'FARANAL (POB.)',
    },
    {
        CITY: 'SAN-FELIPE',
        BARANGAY: 'FERIA (POB.)',
    },
    {
        CITY: 'SAN-FELIPE',
        BARANGAY: 'MALOMA',
    },
    {
        CITY: 'SAN-FELIPE',
        BARANGAY: 'MANGLICMOT (POB.)',
    },
    {
        CITY: 'SAN-FELIPE',
        BARANGAY: 'ROSETE (POB.)',
    },
    {
        CITY: 'SAN-FELIPE',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'SAN-FELIPE',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-FELIPE',
        BARANGAY: 'SINDOL',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'AGLAO',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'BUHAWEN',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'BURGOS (POB.)',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'CONSUELO NORTE',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'CONSUELO SUR (POB.)',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'LA PAZ (POB.)',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'LAOAG',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'LINASIN',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'LINUSUNGAN',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'LUCERO (POB.)',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'NAGBUNGA',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'RABANES',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'SAN GUILLERMO (POB.)',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'SAN-MARCELINO',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'ANINGWAY SACATIHAN',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'ASINAN POBLACION',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'ASINAN PROPER',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'BARACA-CAMACHILE (POB.)',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'BATIAWAN',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'CALAPACUAN',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'CALAPANDAYAN (POB.)',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'CAWAG',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'ILWAS (POB.)',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'MANGAN-VACA',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'MATAIN',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'NAUGSOL',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'PAMATAWAN',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'SUBIC',
        BARANGAY: 'WAWANDUE (POB.)',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'BABANCAL',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'BINABALIAN',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'CATOL',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'DAMPAY',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'LAUIS',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'LIBERTADOR',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MALABON (SAN ROQUE)',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'MALIMANGA',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'PAMIBIAN',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'PANAYONAN',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'PINAGREALAN',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'SINABACAN',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'TAPOSO',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'UACON',
    },
    {
        CITY: 'CANDELARIA',
        BARANGAY: 'YAMOT',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'ANGELES',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'ANTIPOLO (POB.)',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'BURGOS (POB.)',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'EAST DIRITA',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'LUNA (POB.)',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'PUNDAQUIT',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAN ESTEBAN',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAN GREGORIO (POB.)',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'WEST DIRITA',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'ALUSIIS',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'BEDDENG',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'CANDELARIA (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'DALLIPAWEN',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'GRULLO',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'LIBERTAD (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'NAMATACAN',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'NATIVIDAD (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'OMAYA',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'PAITE',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'PATROCINIO (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'SAN PASCUAL (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'SAN RAFAEL (POB.)',
    },
    {
        CITY: 'SAN-NARCISO',
        BARANGAY: 'SIMINUBLAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BABUYAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BANGCOL',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BAYTO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BIAY',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BOLITOC',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BULAWON',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'CANAYNAYAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'GAMA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'GUINABON',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'GUISGUIS',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LIPAY',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LUCAPON NORTH',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LUCAPON SOUTH',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MALABAGO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'NAULO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PAGATPAT',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PAMONORAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TABALONG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TUBOTUBO NORTH',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TUBOTUBO SOUTH',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'BIANUAN',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'CALABGAN',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'CALANGCUASAN',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'CALANTAS',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'CULAT',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'DIBACONG',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'DIBET',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'DITINAGYAN',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'ESTEVES',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'LUAL',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'MARIKIT',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'TABAS',
    },
    {
        CITY: 'CASIGURAN',
        BARANGAY: 'TINIB',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'DIBALO',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'DITEKI',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'DITUMABO',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'L. PIMENTEL',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'NONONG SENIOR',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'REAL',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'ZARAH',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BUHANGIN',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'CALABUANAN',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'OBLIGACION',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'PINGIT',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'RESERVA',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'SUCLAYIN',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'ZABALI',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DIAGYAN',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DICABASAN',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DILAGUIDI',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DIMASESET',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DINIOG',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'MALIGAYA (POB.)',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'MANGGITAHAN',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'MASAGANA (POB.)',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'ABULEG',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'DIBARAYBAY',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'DITAWINI',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'MAPALAD',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'NIPOO (BULO)',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'PALEG',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'SIMBAHAN',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'APLAYA',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'BUTAS NA BATO',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'CABOG (MATAWE)',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'CARAGSACAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'DAVILDAVILAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'DIKAPANIKIAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'IBONA',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'PALTIC',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'TANAWAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'UMIRAY (MALAMIG)',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'BORLONGAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIAMANEN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIANED',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIARABASIN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIBUTUNAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIMABUNO',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DINADIAWAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DITALE',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'GUPA',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'LABOY',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'LIPIT',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'LOBBOT',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'MIJARES',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'MUCDOL',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'PUANGI',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'SALAY',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'SAPANGKAWAYAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'TOYTOYAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'ALCALA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAGTU',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BANGCO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAUBO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAYANIHAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAZAL',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'CABITUCULAN EAST',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'CABITUCULAN WEST',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'CADAYACAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DEBUCAO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DETAILEN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIAAT',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIALATMAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIANAWAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIKILDIT',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIMANPUDSO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIOME',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'ESTONILO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'FLORIDA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'GALINTUJA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'QUIRINO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'RAMADA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN LEONARDO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SUGUIT',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'WENCESLAO',
    }
];
